import React, { useMemo } from 'react';
import './style.scss';
import { allBets, getAvailableBets } from 'shared';
import Button from '../../../components/controls/button';
import Dialog from '../../../components/general/dialog';
import { IFightNft } from '../../../interfaces/FightNft';

interface Props {
  opened: boolean;
  onClose: () => any;
  openNotEnough: () => any;
  onSelect: (nft: IFightNft, bet: number) => void;
  nft?: IFightNft;
  balance: number;
}

const PickBetDialog = ({
  opened,
  onClose,
  openNotEnough,
  nft,
  balance,
  onSelect
}: Props) => {
  const availableBets = useMemo<number[]>(() => {
    if (nft?.rank?.name) {
      return getAvailableBets(nft.rank.name);
    }
    return [];
  }, [nft]);

  if (balance < 0 || !nft) return null;

  const handleClick = (bet: number) => {
    const actualBalance = balance ? balance : 0;
    if (bet > actualBalance) {
      openNotEnough();
    } else {
      onSelect(nft, bet);
    }
    onClose();
  };

  return (
    <Dialog
      opened={opened}
      onClose={onClose}
      maxWidth='sm'
      centered
      fullWidth
      className='pick-bet-dialog'
    >
      <h2 className='pbd-header body-1'>WAGER $CREAM OVER THE BATTLE</h2>
      <div className='pbd-buttons'>
        {allBets.map((bet) => (
          <Button
            variant='contained'
            color={bet === 0 ? 'secondary' : 'primary'}
            disabled={!availableBets.includes(bet)}
            onClick={() => handleClick(bet)}
            key={bet}
            fullWidth
            className='pbd-button'
            pixelFont={bet !== 0}
          >
            {bet === 0 ? 'Free' : bet}
          </Button>
        ))}
      </div>
      <p>
        To unlock more wagers, level up your nifty hand in rank in battles. 
        <br />
        <br />
        Note that free fights give fewer level upgrades.
      </p>
    </Dialog>
  );
};

export default PickBetDialog;
